import {
  buildSentryWebOptions,
  filterSentryBreadcrumb,
  filterSentryEvent,
} from "@mube/observability/sentry-web"
import * as Sentry from "@sentry/nextjs"
import { readPublicConfig } from "./lib/public-config/shared.js"

const EMPTY_VARIABLE = ""

const browserConfig = typeof document === "undefined" ? undefined : readPublicConfig(document)

if (browserConfig?.telemetryEnabled === true) {
  void import("./lib/observability/browser-tracing.js").then(({ registerBrowserTracing }) => {
    registerBrowserTracing({
      telemetryEnabled: true,
      appEnv: browserConfig.appEnv,
      appVersion: browserConfig.appVersion,
    })
  })
}

if (browserConfig?.sentryDsn !== undefined && browserConfig.sentryDsn !== EMPTY_VARIABLE) {
  const sentryOptions = buildSentryWebOptions({
    dsn: browserConfig.sentryDsn,
    appEnv: browserConfig.appEnv,
    appVersion: browserConfig.appVersion,
    replayOnErrorSampleRate: browserConfig.sentryReplayOnErrorSampleRate,
  })
  Sentry.init({
    dsn: browserConfig.sentryDsn,
    environment: sentryOptions.environment,
    release: sentryOptions.release,
    replaysSessionSampleRate: sentryOptions.replaysSessionSampleRate,
    replaysOnErrorSampleRate: sentryOptions.replaysOnErrorSampleRate,
    beforeSend: filterSentryEvent,
    beforeBreadcrumb: filterSentryBreadcrumb,
    integrations: [Sentry.replayIntegration(sentryOptions.replay)],
  })
}
